import { render } from "./App.vue?vue&type=template&id=243b9c85"
const script = {}

import "./App.vue?vue&type=style&index=0&id=243b9c85&lang=scss"

import exportComponent from "E:\\work\\project_4\\核验\\heyan\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__